module.exports = __webpack_public_path__ + "img/caret-down-square-fill.678d9f30.svg";